import { customKpi, InfoDrawerKpiEntry } from 'components/InfoDrawer/InfoDrawerKpiEntry';
import { InfoDrawerKpis } from 'components/InfoDrawer/InfoDrawerKpis';
import { toMarkdownVsCategoryMeasure } from 'components/price/priceMeasures';
import { useModelService } from 'services/model/model.service';

function usePriceEntityInfoContentKpis(): InfoDrawerKpiEntry[] {
  const { getMeasures } = useModelService();
  const [avgSoldPrice, avgPriceMarkdown, soldAtOriginalPrice] = getMeasures([
    'itemSlsGmvValExtOD',
    'itemSlsMkdRateExtOD',
    'slsAtOmvQtyRateOD',
  ]);

  return [
    customKpi('avgSoldPrice', {
      titleId: 'model.metric.itemSlsGmvVal.name',
      descriptionId: 'price.info.avgSoldPrice.description',
      measure: avgSoldPrice,
    }),
    customKpi('avgPriceMarkdown', {
      titleId: avgPriceMarkdown.metric.translationId,
      descriptionId: 'price.info.avgPriceMarkdown.description',
      measure: avgPriceMarkdown,
    }),
    customKpi('soldAtOriginalPrice', {
      titleId: 'model.metric.slsAtOmvQtyRate.name',
      descriptionId: 'price.info.soldAtOriginalPrice.description',
      measure: soldAtOriginalPrice,
    }),
    customKpi('markdownVsCategory', {
      titleId: 'price.kpi.markdownVsCategory',
      descriptionId: 'price.info.markdownVsCategory.description',
      measure: toMarkdownVsCategoryMeasure(avgPriceMarkdown),
    }),
  ];
}

export function PriceEntityInfoContent() {
  const kpis = usePriceEntityInfoContentKpis();

  return <InfoDrawerKpis.Default kpis={kpis} />;
}
